import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Box, InputBase, IconButton, Grid } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useQuery } from "@apollo/client";
import CategoryBusinessCard from "../../../pages/customer/categoryBusinessCard";
import { SEARCH } from "../../../graphql/queries";
import { BusinessData } from "../../../types";

const SearchPage = () => {
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState("");
  const [locationQuery, setLocationQuery] = useState("");
  const [dateQuery, setDateQuery] = useState("");

  useEffect(() => {
    // Extract the query parameters from the URL
    const params = new URLSearchParams(location.search);
    const query = params.get("q");
    const locationParam = params.get("location");
    const dateParam = params.get("date");

    if (query) setSearchQuery(query);
    if (locationParam) setLocationQuery(locationParam);
    if (dateParam) setDateQuery(dateParam);
  }, [location.search]);

  const { loading, data, error } = useQuery(SEARCH, {
    variables: {
      query: JSON.stringify({
        searchQuery: searchQuery.toLowerCase(),
        locationQuery: locationQuery.toLowerCase(),
        dateQuery,
        countryId: localStorage.getItem("currentCountryId"),
      }),
    },
  });

  return (
    <>
      {!loading && (
        <>
          <Grid container spacing={2}>
            {data?.search
              ?.filter((business: any) => {
                return (
                  business.displayOnBookingPage === true ||
                  business.businessBookingTypes?.some(
                    (bookingType: { displayOnBookingPage: boolean }) =>
                      bookingType.displayOnBookingPage === true
                  )
                );
              })
              .map((business: any) => (
                <Grid key={business?.id} item xs={12}>
                  <CategoryBusinessCard
                    business={business}
                    url={business?.businessBasic?.url}
                  />
                </Grid>
              ))}
          </Grid>

          {data?.search?.filter((business: any) => {
            return (
              business.displayOnBookingPage === true ||
              business.businessBookingTypes?.some(
                (bookingType: { displayOnBookingPage: boolean }) =>
                  bookingType.displayOnBookingPage === true
              )
            );
          }).length === 0 && (
            <Box textAlign="center" mt={4} fontSize="1rem">
              No businesses matched your search or are public to display.
            </Box>
          )}
        </>
      )}
    </>
  ); 
};

export default SearchPage;
